import {WildlifeEventUpload} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public WildlifeEventUpload: WildlifeEventUpload,
  ) {}
}